import { q } from '@actual-app/core/shared/query';

import { useQuery } from '#hooks/useQuery';

export type Movement = {
  id: string;
  date: string;
  amount: number;
  account: string;
  schedule: string | null;
  category: string | null;
  transfer_id: string | null;
  starting_balance_flag: boolean;
};

/** Bank transactions dated on or after `since`, kept live. */
export function useTransactionsSince(since: string): readonly Movement[] {
  const { data } = useQuery<Movement>(
    () =>
      q('transactions')
        .filter({ date: { $gte: since } })
        .select([
          'id',
          'date',
          'amount',
          'account',
          'schedule',
          'category',
          'transfer_id',
          'starting_balance_flag',
        ]),
    [since],
  );
  return data ?? [];
}

/** The accounts among `ids` whose bank has sent at least one movement. */
export function useAccountsWithBankMovements(
  ids: readonly string[],
): ReadonlySet<string> {
  // The same accounts in another order are the same question.
  const key = [...ids].sort().join(',');
  const { data } = useQuery<{ account: string }>(
    () =>
      q('transactions')
        .filter({
          account: { $oneof: key.split(',').filter(Boolean) },
          imported_id: { $ne: null },
        })
        .groupBy('account')
        .select(['account']),
    [key],
  );
  return new Set((data ?? []).map(row => row.account));
}
